
import { defineComponent } from 'vue';
import { adService } from './AdService';
import AdStatisticsList from '@/ad/components/AdStatisticsList.vue';

export default defineComponent({
  components: {
    AdStatisticsList,
  },
  data() {
    return {
      isLoading: false,
      estateAgencyStatistics: null as any,
      userStatistics: null as any,
    };
  },
  async created() {
    this.isLoading = true;
    try {
      const params = {} as any;
      params.isEstateAgency = true;
      this.estateAgencyStatistics = (await adService.getStatistics(params)).data;
      this.userStatistics = (await adService.getStatistics({})).data;
      this.isLoading = false;
    } catch (error) {
      console.error(error);
    }
  },
});
